import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Box } from '@mui/material';

import { styles } from './styles';
import { registeredModals } from '@components/modals/registeredModals';
import { Modals } from '@core/Modal';
import SuspenseLoading from '@components/common/SuspenseLoading';

export type AuthLayoutProps = {};

const AuthLayout: React.FC<AuthLayoutProps> = () => {
  return (
    <Box sx={styles.root}>
      <Modals registeredModals={registeredModals} />
      <Suspense fallback={<SuspenseLoading />}>
        <Box sx={styles.wrapper}>
          <Box sx={styles.container}>
            <Outlet />
          </Box>
        </Box>
      </Suspense>
    </Box>
  );
};

export default AuthLayout;
